import React from "react";
import { Button, Container, Grid, useMediaQuery } from "@mui/material";
import NotFoundImg from "../../Assests/Images/notFound.svg";
import Header from "../../Components/Header";
import Footer from "../Homepage/footer";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const Navigate = useNavigate()

  return (
    <div>
      <Header />
      <div style={{height: isSmallScreen?"75vh":"70vh"}}>
        <section>
          <Container>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8} textAlign="center">
                <img
                  src={NotFoundImg}
                  alt="NotFound"
                  style={{
                    width: isSmallScreen ? "80px" : "100px",
                    marginBottom: isSmallScreen ? "30px" : "0px",
                    marginTop: "20px"
                  }}
                />
                <h1
                  style={{
                    fontFamily: "Font1",
                    fontSize: isSmallScreen ? "32px" : "42px",
                    fontWeight: 900,
                    color: "#141c3a",
                    marginBottom: isSmallScreen ? "30px" : "40px",
                    letterSpacing: "2px",
                    textShadow: isSmallScreen
                      ? "0px 0.5px, 0.5px 0px, 0.5px 0.5px"
                      : "0px 1px, 1px 0px, 1px 1px",
                    textAlign: "center",
                  }}
                >
                  Looks like you're lost
                </h1>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    borderRadius: "60px",
                    border: "2px solid #6E07F3",
                    color: "#6E07F3",
                    fontSize: isSmallScreen ? "14px" : "18px",
                    padding: isSmallScreen ? "6px 20px" : "8px 25px",
                    "&:hover": {
                      backgroundColor: "#6E07F3",
                      color: "white",
                      border: "2px solid #6E07F3",
                    },
                    textTransform: "none",
                    fontFamily: "Font2",
                    // mb:"120px"
                  }}
                  onClick={() => Navigate("/")}
                >
                  Return Home
                </Button>
              </Grid>
            </Grid>
          </Container>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
